module.exports = __webpack_public_path__ + "static/img/cont64 (1).a8fd75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (1).jpg
// module id = +10m
// module chunks = 0